import type React from "react";
import { useEffect, useState } from "react";
import type { KnowledgeSource, Product } from "@qbanq/shared";
import { api } from "../api/client";

export function KnowledgeSourcesPage() {
  const [products, setProducts] = useState<Product[]>([]);
  const [sources, setSources] = useState<KnowledgeSource[]>([]);
  const [productId, setProductId] = useState("");
  const [type, setType] = useState<"url" | "text">("url");
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [content, setContent] = useState("");

  function load() {
    void api.get<Product[]>("/api/products").then((p) => {
      setProducts(p);
      if (!productId && p[0]) setProductId(p[0].id);
    });
    void api.get<KnowledgeSource[]>("/api/knowledge").then(setSources);
  }
  useEffect(load, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    await api.post("/api/knowledge", {
      product_id: productId,
      type,
      title,
      location: type === "url" ? location : undefined,
      content: type === "text" ? content : undefined,
    });
    setTitle("");
    setLocation("");
    setContent("");
    load();
  }

  async function remove(id: string) {
    await api.del(`/api/knowledge/${id}`);
    load();
  }

  return (
    <div>
      <h2>Knowledge Sources</h2>
      <div className="card">
        <h3>Add source</h3>
        <form onSubmit={create}>
          <div className="row">
            <div className="field" style={{ flex: 1 }}>
              <label>Product</label>
              <select value={productId} onChange={(e) => setProductId(e.target.value)}>
                {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div className="field" style={{ width: 140 }}>
              <label>Type</label>
              <select value={type} onChange={(e) => setType(e.target.value as "url" | "text")}>
                <option value="url">url</option>
                <option value="text">text</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Title</label>
            <input value={title} onChange={(e) => setTitle(e.target.value)} />
          </div>
          {type === "url" ? (
            <div className="field">
              <label>URL</label>
              <input value={location} onChange={(e) => setLocation(e.target.value)} />
            </div>
          ) : (
            <div className="field">
              <label>Content</label>
              <textarea rows={4} value={content} onChange={(e) => setContent(e.target.value)} />
            </div>
          )}
          <button className="btn" type="submit">Add</button>
        </form>
      </div>

      <div className="card">
        <table>
          <thead><tr><th>Title</th><th>Type</th><th>Product</th><th></th></tr></thead>
          <tbody>
            {sources.map((s) => (
              <tr key={s.id}>
                <td>{s.title}</td>
                <td className="muted">{s.type}</td>
                <td>{products.find((p) => p.id === s.product_id)?.name ?? s.product_id}</td>
                <td><button className="btn danger" onClick={() => remove(s.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
